import BaseApi from "./BaseApi";
class committeeApi extends BaseApi {
  async createCommitteeMember(data) {
    return await this.API({
      url: "/committee/create-committee-member",
      data: data,
      method: "post",
    });
  }

  async newSteeringMember(data) {
    return await this.API({
      url: "/committee/new-steering-member",
      data: data,
      method: "post",
    });
  }

  async getAllCommitteMembers(data) {
    return await this.API({
      url: "/committee/get-all-committe-members",
      data: data,
      method: "post",
    });
  }

  async deleteMember(data) {
    return await this.API({
      url: "/committee/delete-member",
      data: data,
      method: "post",
    });
  }

  async retreatDisabledForMem(data) {
    return await this.API({
      url: "/committee/retreat-disabled-for-Member",
      data: data,
      method: "post",
    });
  }

  async committeeAccessedRetreats(data) {
    return await this.API({
      url: "/committee/committee-accessed-retreats",
      data: data,
      method: "post",
    });
  }

  async deleteParishMembers(data) {
    return await this.API({
      url: "/committee/delete-parish-members",
      data: data,
      method: "post",
    });
  }
}

export default committeeApi;
